import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { assetUrl } from "../utils/api";
import { formatRelativeTime } from "../utils/datetime";
import { formatCityLabel } from "../utils/resolveRegion";
import VerificationBadges from "../components/VerificationBadges";

function formatViewTime(iso) {
  return formatRelativeTime(iso);
}

export default function ProfileViewsPage() {
  const navigate = useNavigate();
  const currentUserId = Number(localStorage.getItem("user_id"));
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [recentTotal, setRecentTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUserId) {
      navigate("/login");
      return;
    }

    setLoading(true);
    fetch(`/api/profile-views/mine?user_id=${currentUserId}&page=1&page_size=50`)
      .then((res) => res.json())
      .then((data) => {
        setItems(data.items || []);
        setTotal(data.unique_viewers || 0);
        setRecentTotal(data.recent_total || 0);
      })
      .finally(() => setLoading(false));
  }, [currentUserId, navigate]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800">谁看了我</h1>
        <p className="text-sm text-gray-500 mt-1">
          登录会员查看您资料时会出现在这里（同一人 6 小时内重复浏览只记一次）
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-pink-50 rounded-xl p-4 text-center">
          <p className="text-sm text-gray-500">来访人数</p>
          <p className="text-2xl font-bold text-pink-600">{total}</p>
        </div>
        <div className="bg-pink-50 rounded-xl p-4 text-center">
          <p className="text-sm text-gray-500">总浏览次数</p>
          <p className="text-2xl font-bold text-pink-600">{recentTotal}</p>
        </div>
      </div>

      {loading ? (
        <p className="text-center text-gray-400 py-10">加载中...</p>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-gray-400 space-y-2">
          <p className="text-4xl">👀</p>
          <p>还没有会员看过您的资料</p>
          <p className="text-sm">完善资料并去「寻找对象」曝光，更容易被看到</p>
          <Link to="/discover" className="inline-block mt-4 text-pink-500 hover:underline">
            去寻找对象
          </Link>
        </div>
      ) : (
        <ul className="divide-y rounded-xl border">
          {items.map((item) => (
            <li key={item.id}>
              <Link
                to={`/user/${item.id}`}
                className="flex items-center gap-4 p-4 hover:bg-pink-50 transition"
              >
                {item.avatar ? (
                  <img
                    src={assetUrl(item.avatar)}
                    alt=""
                    className="w-14 h-14 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-14 h-14 rounded-full bg-pink-100 text-pink-600 flex items-center justify-center font-bold">
                    {(item.name || "?").slice(0, 1)}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-gray-800">{item.name}</span>
                    <VerificationBadges
                      verification={item.verification}
                      userId={item.id}
                      userName={item.name}
                      variant="compact"
                    />
                  </div>
                  <p className="text-sm text-gray-500">
                    {item.age ? `${item.age}岁` : ""}
                    {(() => {
                      const loc = formatCityLabel(
                        item.province,
                        item.city,
                        item.district,
                        ""
                      );
                      return loc ? ` · ${loc}` : "";
                    })()}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    {formatViewTime(item.viewed_at)}
                    {item.view_count > 1 ? ` · 共看过 ${item.view_count} 次` : ""}
                  </p>
                </div>
                <span className="text-pink-400 text-sm shrink-0">查看资料 →</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
